import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";
import DefaultImg from "../assets/images/product/Default_img.jpg";

class ItemDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
    };
    this.toggleTab = this.toggleTab.bind(this);
  }
  CloseModel() {
    if (this.props.modelClose) {
      this.props.modelClose();
      this.setState({
        activeTab: 1,
      });
    }
  }
  toggleTab(tab, product) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        this.setState({
          activeTab: tab,
          item_details: product,
        });
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.modelOpen}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader
            toggle={() => {
              this.CloseModel();
            }}
          >
            Item Details ({this.props.item.code})
          </ModalHeader>
          <ModalBody className="pt-0">
            <Row className="justify-content-center">
              <Col md={12}>
                <Nav tabs className="nav-tabs-custom ">
                  <NavItem>
                    <NavLink
                      onClick={() => {
                        this.toggleTab(1, null);
                      }}
                      className={classnames(
                        { active: this.state.activeTab === 1 },
                        "pt-3 font-weight-bold card-title-16"
                      )}
                    >
                      Details
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames(
                        { active: this.state.activeTab === 2 },
                        "pt-3 font-weight-bold card-title-16"
                      )}
                    >
                      {this.state.activeTab === 2 && "Images"}
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId={1}>
                    <Row>
                      <Col md={5} className="text-center">
                        <div className="product-detail">
                          <img
                            src={
                              this.props.item.product?.image == null
                                ? DefaultImg
                                : this.props.item?.product?.image
                            }
                            alt="product-img"
                            title="product-img"
                            className="product-img img-fluid mx-auto tab-img rounded"
                          />
                        </div>
                      </Col>
                      <Col xl={7}>
                        <div className="mt-4 mt-xl-3">
                          <div>
                            <h5 className="mt-1 mb-1">
                              {this.props.item.product?.name}
                            </h5>
                            <div>
                              <p className="d-inline-block">
                                Code:
                                {this.props.item.product?.code === "nan"
                                  ? "***"
                                  : this.props.item.product?.code}
                              </p>
                              {this.props.ItemLevel === "MRLevel" && (
                                <>
                                  {this.props.item.sritemimages?.length !==
                                  0 ? (
                                    <Link
                                      to="#"
                                      className="float-right"
                                      isDisabled={true}
                                      onClick={() => {
                                        this.toggleTab(2);
                                      }}
                                    >
                                      <u> View Images</u>
                                    </Link>
                                  ) : (
                                    <span className="float-right">
                                      No Images
                                    </span>
                                  )}
                                </>
                              )}
                              {(this.props.ItemLevel === "RFQLevel" ||
                                this.props.ItemLevel === "QLevel" ||
                                this.props.ItemLevel === "POLevel") && (
                                <>
                                  {this.props.item.mrdata?.sritemimages
                                    .length !== 0 ? (
                                    <>
                                      <Link
                                        to="#"
                                        className="float-right"
                                        isDisabled={true}
                                        onClick={() => {
                                          this.toggleTab(2);
                                        }}
                                      >
                                        <u> View Images</u>
                                      </Link>
                                    </>
                                  ) : (
                                    <>
                                      <span className="float-right">
                                        No Images
                                      </span>
                                    </>
                                  )}
                                </>
                              )}
                              {this.props.ItemLevel === "PILevel" && (
                                <>
                                  {this.props.item?.sritemimages?.length !==
                                  0 ? (
                                    <>
                                      <Link
                                        to="#"
                                        className="float-right"
                                        isDisabled={true}
                                        onClick={() => {
                                          this.toggleTab(2);
                                        }}
                                      >
                                        <u> View Images</u>
                                      </Link>
                                    </>
                                  ) : (
                                    <>
                                      <span className="float-right">
                                        No Images
                                      </span>
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          <hr className="my-1" />

                          <Row>
                            <Col md={12}>
                              <div className="Order-panel-content">
                                <h5 className="font-size-14">
                                  Specification :
                                </h5>
                                <div className="list-column">
                                  <ul className="list-style-two p-0 product-desc-list">
                                    <li className="clearfix">
                                      <span className="ttl">
                                        <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                        Make:
                                      </span>
                                      <span className="dtl">
                                        {this.props.item.make}
                                      </span>
                                    </li>
                                    <li className="clearfix">
                                      <span className="ttl">
                                        <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                        Section :
                                      </span>
                                      <span className="dtl">
                                        {this.props.item.product?.section?.name}
                                      </span>
                                    </li>
                                    <li className="clearfix">
                                      <span className="ttl">
                                        <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                        Required Date:
                                      </span>
                                      <span className="dtl">
                                        {this.props.item.date}
                                      </span>
                                    </li>
                                    <li className="clearfix">
                                      <span className="ttl">
                                        <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                        Item Unit :
                                      </span>
                                      <span className="dtl">
                                        {
                                          this.props.item.product?.baseunit
                                            ?.name
                                        }
                                      </span>
                                    </li>

                                    <li className="clearfix">
                                      <span className="ttl">
                                        <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                        Department :
                                      </span>
                                      <span className="dtl">
                                        {
                                          this.props.item.product?.department
                                            ?.name
                                        }
                                      </span>
                                    </li>
                                    <li className="clearfix">
                                      <span className="ttl">
                                        <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                        Category :
                                      </span>
                                      <span className="dtl">
                                        {
                                          this.props.item.product?.category
                                            ?.name
                                        }
                                      </span>
                                    </li>
                                    <li className="clearfix">
                                      <span className="ttl">
                                        <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                        Product Group :
                                      </span>
                                      <span className="dtl">
                                        {this.props.item.product?.group?.name}
                                      </span>
                                    </li>
                                    <li className="clearfix">
                                      <span className="ttl">
                                        <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                        Specifications :
                                      </span>
                                      <span className="dtl">
                                        {this.props.item.product?.description}
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId={2}>
                    <div
                      style={{
                        minHeight: "450px",
                      }}
                    >
                      <div className="d-inline-block mt-2 ">
                        {this.props.ItemLevel === "MRLevel" && (
                          <>
                            {this.props.item?.sritemimages?.length !== 0 ? (
                              <>
                                {this.props.item.sritemimages?.map(
                                  (imageURL) => (
                                    <div className="product-detail mt-0 text-center d-inline-block">
                                      <img
                                        src={imageURL.image}
                                        alt="..."
                                        className="product-img  img-fluid mx-auto tab-img rounded"
                                        style={{
                                          height: "150px",
                                          width: "250px",
                                        }}
                                      />
                                    </div>
                                  )
                                )}
                              </>
                            ) : (
                              <div className="text-center">No Images</div>
                            )}
                          </>
                        )}
                        {this.props.ItemLevel === "PILevel" && (
                          <>
                            {this.props.item?.sritemimages?.length !== 0 ? (
                              <>
                                {this.props.item?.sritemimages?.map(
                                  (imageURL) => (
                                    <div className="product-detail mt-0 text-center d-inline-block">
                                      <img
                                        src={imageURL.image}
                                        alt="..."
                                        className="product-img  img-fluid mx-auto tab-img rounded"
                                        style={{
                                          height: "150px",
                                          width: "250px",
                                        }}
                                      />
                                    </div>
                                  )
                                )}
                              </>
                            ) : (
                              <div className="text-center">No Images</div>
                            )}
                          </>
                        )}
                        {(this.props.ItemLevel === "RFQLevel" ||
                          this.props.ItemLevel === "QLevel" ||
                          this.props.ItemLevel === "POLevel") && (
                          <>
                            {this.props.item.mrdata?.sritemimages?.map(
                              (imageURL) => (
                                <div className="product-detail mt-0 text-center d-inline-block">
                                  <img
                                    src={imageURL.image}
                                    alt="..."
                                    className="product-img  img-fluid mx-auto tab-img rounded"
                                    style={{
                                      height: "150px",
                                      width: "250px",
                                    }}
                                  />
                                </div>
                              )
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {};

export default connect(mapStatetoProps, {})(ItemDetails);
